/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import React from 'react';
import Modal2 from 'components/modals/Modal2/Modal2';
import { useIntl } from 'react-intl';
import styles from './style.cssmodule.css';

function ModalTermsOfService() {
  const [termsModalOpen, setTermsModalOpen] = React.useState(false);
  const { formatMessage: t } = useIntl();

  return (
    <React.Fragment>
      <li onClick={() => setTermsModalOpen(true)}>{t({ id: 'footer.termsConditions' })}</li>
      <Modal2
        isOpen={termsModalOpen}
        size="large"
        onClose={() => setTermsModalOpen(false)}
        title={t({ id: 'info.termsOfService' })}
        modalType="info"
        actions={[
          {
            label: 'button.close',
            onClick: () => setTermsModalOpen(false),
          },
        ]}
      >
        <div className={styles.termsOfService}>
          <h5>{t({ id: 'info.termsOfService.title1' })}</h5>
          <p>{t({ id: 'info.termsOfService.content11' })}</p>
          <p>{t({ id: 'info.termsOfService.content12' })}</p>
          <p>{t({ id: 'info.termsOfService.content13' })}</p>
          <p>{t({ id: 'info.termsOfService.content14' })}</p>

          <h5>{t({ id: 'info.termsOfService.title2' })}</h5>
          <p>{t({ id: 'info.termsOfService.content21' })}</p>
          <p>{t({ id: 'info.termsOfService.content22' })}</p>
          <p>{t({ id: 'info.termsOfService.content23' })}</p>
          <p>{t({ id: 'info.termsOfService.content24' })}</p>
          <p>{t({ id: 'info.termsOfService.content25' })}</p>
          <p>{t({ id: 'info.termsOfService.content26' })}</p>
          <p>{t({ id: 'info.termsOfService.content27' })}</p>
          <p>{t({ id: 'info.termsOfService.content28' })}</p>
          <p>{t({ id: 'info.termsOfService.content29' })}</p>
          <p>{t({ id: 'info.termsOfService.content30' })}</p>
          <p>{t({ id: 'info.termsOfService.content31' })}</p>
          <p>{t({ id: 'info.termsOfService.content32' })}</p>
          <p>{t({ id: 'info.termsOfService.content33' })}</p>
          <p>{t({ id: 'info.termsOfService.content34' })}</p>
          <p>{t({ id: 'info.termsOfService.content35' })}</p>
          <p>{t({ id: 'info.termsOfService.content36' })}</p>
          <p>{t({ id: 'info.termsOfService.content37' })}</p>
          <p>{t({ id: 'info.termsOfService.content38' })}</p>
        </div>
      </Modal2>
    </React.Fragment>
  );
}

export default ModalTermsOfService;



// WEBPACK FOOTER //
// ./components/templates/AuthenticationLayout/components/ModalTermsOfService/ModalTermsOfService.jsx